import { GetInvoicesPaginatedResponse } from '../../app/features/wallet/domain/invoices.model';
import { InvoiceNameStatus } from '../../app/features/wallet/infrastructure/enums/invoice-name-status.enum';
import { InvoiceReason } from '../../app/features/wallet/infrastructure/enums/invoice-reason.enum';
import { InvoiceType } from '../../app/features/wallet/infrastructure/enums/invoice-type.enum';

export const invoicesListResponseMock: GetInvoicesPaginatedResponse = {
    data: [
        {
            id: '046b6c7f-0b8a-43b9-b35d-6489e6daee91',
            invoiceNumber: 'NM-0000175075',
            issueDate: '2025-04-01T07:00:00Z',
            status: {
                name: InvoiceNameStatus.PAID,
                reason: InvoiceReason.INVOICE_PAID,
                dateTime: '2025-07-10T09:37:53.777363Z',
            },
            type: InvoiceType.REGULAR,
            totalAmount: {
                amount: 120.96,
                currency: 'USD',
            },
        },
        {
            id: '046b6c7f-0b8a-43b9-b35d-6489e6daee92',
            invoiceNumber: 'NM-0000175076',
            issueDate: '2025-04-01T07:00:00Z',
            status: {
                name: InvoiceNameStatus.UNCOLLECTIBLE,
                reason: InvoiceReason.INVOICE_UNCOLLECTIBLE,
                dateTime: '2025-07-10T09:37:53.777363Z',
            },
            type: InvoiceType.REGULAR,
            totalAmount: {
                amount: 120.96,
                currency: 'USD',
            },
        },
    ],
    pagination: {
        currentPage: 0,
        pageSize: 6,
        totalElements: 2,
        totalPages: 1,
    },
};
